//general
export const PRIMARY_TITLE = "PRIMARY_TITLE";
export const CONTINUE_BUTTON = "CONTINUE_BUTTON";
export const PENDING = "PENDING";
export const UPLOAD_PHOTO = "UPLOAD_PHOTO";
export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";
export const GO_BACK = "Go back";
export const ALREADY_VERIFIED = "ALREADY_VERIFIED";

//menu
export const MENU = "MENU";
export const MENU_ITEM_DATA_PRIVACY = "MENU_ITEM_DATA_PRIVACY";
export const CLOSE_BUTTON = "CLOSE_BUTTON";

//onboarding
export const ONBOARDING_STEP_ONE_MESSAGE = "ONBOARDING_STEP_ONE_MESSAGE";
export const ONBOARDING_STEP_TWO_MESSAGE = "ONBOARDING_STEP_TWO_MESSAGE";
export const ONBOARDING_STEP_THREE_MESSAGE = "ONBOARDING_STEP_THREE_MESSAGE";

//choose_supervisor
export const CHOOSE_SUPERVISOR_WHO_ARE_YOU = "CHOOSE_SUPERVISOR_WHO_ARE_YOU";
export const CHOOSE_SUPERVISOR_PRIVATE = "CHOOSE_SUPERVISOR_PRIVATE";
export const CHOOSE_SUPERVISOR_IF_PRIVATE = "CHOOSE_SUPERVISOR_IF_PRIVATE";
export const CHOOSE_SUPERVISOR_BUSINESS = "CHOOSE_SUPERVISOR_BUSINESS";
export const CHOOSE_SUPERVISOR_IF_BUSINESS = "CHOOSE_SUPERVISOR_IF_BUSINESS";

//registration
export const REGISTRATION_SUPERVISOR_TITLE = "REGISTRATION_SUPERVISOR_TITLE";
export const REGISTRATION_FIRST_NAME = "REGISTRATION_FIRST_NAME";
export const REGISTRATION_LAST_NAME = "REGISTRATION_LAST_NAME";
export const REGISTRATION_DOB = "REGISTRATION_DOB";
export const REGISTRATION_MOBILE_PHONE = "REGISTRATION_MOBILE_PHONE";
export const REGISTRATION_EMAIL = "REGISTRATION_EMAIL";
export const REGISTRATION_ADDRESS = "REGISTRATION_ADDRESS";
export const REGISTRATION_CITY = "REGISTRATION_CITY";
export const REGISTRATION_POSTAL_CODE = "REGISTRATION_POSTAL_CODE";
export const REGISTRATION_COUNTRY = "REGISTRATION_COUNTRY";
export const REGISTRATION_ACCEPT_PRIVACY = "REGISTRATION_ACCEPT_PRIVACY";
export const REGISTRATION_ACCEPT = "REGISTRATION_ACCEPT";
export const REGISTRATION_DATA_PRIVACY = "REGISTRATION_DATA_PRIVACY";
export const REGISTRATION_COMPANY_TITLE = "REGISTRATION_COMPANY_TITLE";
export const REGISTRATION_COMPANY_NAME = "REGISTRATION_COMPANY_NAME";
export const REGISTRATION_DISPLAY_NAME = "REGISTRATION_DISPLAY_NAME";
export const REGISTRATION_REG_NUMBER = "REGISTRATION_REG_NUMBER";
export const REGISTRATION_LOGO = "REGISTRATION_LOGO";

//home
export const HOME_SCAN_TESTKIT = "HOME_SCAN_TESTKIT";
export const HOME_SUPERVISE_TEST = "HOME_SUPERVISE_TEST";
export const HOME_GET_HELP = "HOME_GET_HELP";

//privacy policy
export const PRIVACY_POLICY_TEXT = "PRIVACY_POLICY_TEXT";

//get help
export const HELP_MAIN_TITLE = "HELP_MAIN_TITLE";
export const HELP_SUBTITLE1 = "HELP_SUBTITLE1";
export const HELP_SUBTEXT11 = "HELP_SUBTEXT11";
export const HELP_SUBTEXT12 = "HELP_SUBTEXT12";
export const HELP_SUBTITLE2 = "HELP_SUBTITLE2";
export const HELP_SUBTEXT2 = "HELP_SUBTEXT2";

//error messages
export const ERROR_PROCESSING_QR = "ERROR_PROCESSING_QR";
export const ERROR_SIGNATURE_VERIFICATION_FAILED =
  "ERROR_SIGNATURE_VERIFICATION_FAILED";
export const ERROR_PARSING_QR = "ERROR_PARSING_QR";
export const ERROR_SOMETHING_WENT_WRONG = "ERROR_SOMETHING_WENT_WRONG";
export const ERROR_TEST_ALREADY_VERIFIED = "ERROR_TEST_ALREADY_VERIFIED";
export const ERROR_VERIFICATION_FAILED = "ERROR_VERIFICATION_FAILED";

// photos permission
export const PERMISSION_TITLE = "PERMISSION_TITLE";
export const PERMISSION_TEXT = "PERMISSION_TEXT";
export const PERMISSION_SETTINGS = "PERMISSION_SETTINGS";
export const PERMISSION_DENY = "PERMISSION_DENY";

//success messages
export const SUCCESS_TEST_VERIFIED = "SUCCESS_TEST_VERIFIED";

//validation messages
export const VALIDATION_REQUIRED_FIELD = "VALIDATION_REQUIRED_FIELD";
export const VALIDATION_ENTER_VALID_DOB = "VALIDATION_ENTER_VALID_DOB";
export const VALIDATION_18_YEARS_OLD = "VALIDATION_18_YEARS_OLD";
export const VALIDATION_ENTER_VALID_EMAIL = "VALIDATION_ENTER_VALID_EMAIL";
export const VALIDATION_ENTER_VALID_PHONE = "VALIDATION_ENTER_VALID_PHONE";
export const VALIDATION_ENTER_VALID_POSTAL_CODE =
  "VALIDATION_ENTER_VALID_POSTAL_CODE";
export const VALIDATION_NOT_A_PASS_ME_CODE = "VALIDATION_NOT_A_PASS_ME_CODE";
export const VALIDATION_SCAN_ON_TEST_CARTRIGE =
  "VALIDATION_SCAN_ON_TEST_CARTRIGE";

export const MOVE_QR_IN_FRAME = "MOVE_QR_IN_FRAME";
export const HOLD_PHONE_STEADY = "HOLD_PHONE_STEADY";

//testing
export const VERIFY_TEST_NEGATIVE_BUTTON = "VERIFY_TEST_NEGATIVE_BUTTON";
export const VERIFY_TEST_POSITIVE_BUTTON = "VERIFY_TEST_POSITIVE_BUTTON";
export const VERIFY_LATER_BUTTON = "VERIFY_LATER_BUTTON";

//form errors
export const PLEASE_PROVIDE_LAST_NAME = "PLEASE_PROVIDE_LAST_NAME";
export const PLEASE_PROVIDE_FIRST_NAME = "PLEASE_PROVIDE_FIRST_NAME";
export const PLEASE_PROVIDE_MOBILE_PHONE_NUMBER =
  "PLEASE_PROVIDE_MOBILE_PHONE_NUMBER";
export const INVALID_PHONE_NUMBER = "INVALID_PHONE_NUMBER";
export const PLEASE_PROVIDE_EMAIL = "PLEASE_PROVIDE_EMAIL";
export const INVALID_EMAIL_ADDRESS = "INVALID_EMAIL_ADDRESS";
export const PLEASE_PROVIDE_ADDRESS = "PLEASE_PROVIDE_ADDRESS";
export const PLEASE_PROVIDE_POSTAL_CODE = "PLEASE_PROVIDE_POSTAL_CODE";
export const POSTAL_CODE_MIN_LENGTH = "POSTAL_CODE_MIN_LENGTH";
export const PLEASE_PROVIDE_CITY = "PLEASE_PROVIDE_CITY";
export const PLEASE_PROVIDE_COUNTRY = "PLEASE_PROVIDE_COUNTRY";
export const TEST_PHOTO_RETAKE = "TEST_PHOTO_RETAKE";
export const TEST_PHOTO_TAKE_IMAGE = "TEST_PHOTO_TAKE_IMAGE";
export const TEST_PHOTO_PAGE_TITLE = "TEST_PHOTO_PAGE_TITLE";
export const TEST_PHOTO_PAGE_BUTTON = "TEST_PHOTO_PAGE_BUTTON";
